import { Box, Typography, Divider } from "@mui/material";
import { hr } from "@/constants/strings.hr";
import { useArticleComments } from "@/hooks/useArticleComments";
import { CommentItem } from "./CommentItem";
import { CommentComposer } from "./CommentComposer";

export function CommentSection({ articleId }: { articleId: string }) {
  const {
    comments,
    newComment,
    setNewComment,
    submitting,
    submitComment,
    isAuthenticated,
    replaceComment,
    removeComment,
  } = useArticleComments(articleId);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {hr.comments.sectionTitle} ({comments.length})
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {isAuthenticated && (
        <CommentComposer
          value={newComment}
          onChange={setNewComment}
          onSubmit={submitComment}
          submitting={submitting}
        />
      )}
      {!isAuthenticated && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 2,
            fontStyle: "italic",
          }}
        >
          {hr.comments.loginPrompt}
        </Typography>
      )}
      {comments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          onUpdated={replaceComment}
          onDeleted={removeComment}
        />
      ))}
      {comments.length === 0 && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            py: 2,
          }}
        >
          {hr.comments.empty}
        </Typography>
      )}
    </Box>
  );
}
